<template>
  <div class="homepage">
    <hero class="background-offwhite" />
    <div class="homepage__search">
      <Searchvilla :key="`Searchvilla${Math.random()}`"
                   instanceName="home"
                   text-arrival="Check-in"
                   text-departure="Check-out"
                   text-destination-label="All destinations"
                   text-find-villas="Search villas"
                   region="homepage"
                   tracking-category="search_hero"
      />
    </div>

    <h2 class="homepage__intro wrapper text-center">
      The Thinking Traveller is the only keyholder to a family of luxury villas and experiences with soul. That’s why we’ve been voted the <span class="italic">Best Villa Rental Company in the World</span> seven years in a row.
    </h2>

    <!-- Featured Collections -->
    <div class="homepage__collections">
      <div class="app-area">
        <app-template-area :area-id="37" />
      </div>

      <div class="homepage__collections--cta text-center">
        <app-link id="16" type="page" class="btn-secondary-dark-sm">
          Search all villas
        </app-link>
      </div>
    </div>

    <TrendingDestinations :destinations="trendingContent" />

    <ExperiencesCarousel />

    <div class="homepage__slideshow">
      <PromoSlider
        :key="`home${slideshowKey}`"
        contain-height
        use-backround-image
        :toggle-nav-visibility="isDesktop"
        show-dots-navigation
        :easing="'none'"
        :slideshow-image-width="slideshowWidth"
        :slideshow-image-height="slideshowHeight"
        :nav-icon-url="require('../assets/img/src/icons/curved-arrow-left-circle.svg')"
        :slideshow-data="slideshowData"
        :nav-icon-size="isMobile ? '26px' : '26px'"
        :nav-icon-position="isMobile ? '40px' : '20px'"
      />
    </div>

    <BlogCarousel :blogIds="[144, 46, 127, 35, 86]" />

    <split-tabbed-block
      :item="splitTabbedContent"
      :bgColour="'#94A57B'"
      :theme="'dark'"
    />

    <newsletterBlock />

    <BannerCTA />
  </div>
</template>

<script>

import Hero from './home/Hero';
import TrendingDestinations from '../components/TrendingDestinations.vue';
import trendingDestinationsContent from '../content/TrendingDestinations';
import ExperiencesCarousel from '../components/ExperiencesCarousel.vue';
import PromoSlider from '../components/PromoSlider/PromoSlider.vue';
import PromoSliderContent from '../content/PromoSliderContent.js';
import BlogCarousel from '../components/BlogCarousel.vue';
import SplitTabbedBlock from '../components/SplitTabbedBlock.vue';
import NewsletterBlock from '../components/NewsletterBlock.vue';
import BannerCTA from '../components/BannerCTA.vue';
import uuid from '../mixins/uuid';
import responsive from '../mixins/responsive.js';

export default {
  components: {
    Hero,
    TrendingDestinations,
    ExperiencesCarousel,
    PromoSlider,
    BlogCarousel,
    SplitTabbedBlock,
    NewsletterBlock,
    BannerCTA,
  },
  mixins: [
    uuid,
    responsive,
  ],
  data() {
    return {
      skey: '746767467467yghf36ted',
    };
  },
  computed: {
    trendingContent() {
      return trendingDestinationsContent.home;
    },
    slideshowData() {
      return PromoSliderContent.promoSliderArray;
    },
    slideshowKey() {
      return this.skey;
    },
    slideshowWidth() {
      return `${this.$store.getters['common/getScreenSize'].innerWidth}px`;
    },
    slideshowHeight() {
      const height = 600;
      const sw = this.$store.getters['common/getScreenSize'].screenWidth / this.$store.getters['common/getScreenSize'].innerWidth;
      const nh = height + (Math.round(height - (sw * height)));
      return sw < 0.6 ? `${nh}px` : `${height}px`;
    },
    splitTabbedContent() {
      return [
        {
          index: 1,
          bgImage: require('../assets/img/src/illustrations/table-setting.svg'),
          category: 'Discover',
          title: 'Sicily',
          text: 'Sicily is the largest and the most diverse island in the Mediterranean. With its intriguing history, enviable climate, stunning beaches, active volcanoes, idyllic archipelagos, mouthwatering cuisine, and excellent wine, it has just about everything you could possibly wish for, and it’s no coincidence that so many of our clients return year after year, always finding something new to explore.',
          cta: 'View more',
          linkId: 26,
          linkType: 'page',
        },
        {
          index: 2,
          bgImage: require('../assets/img/src/illustrations/table-setting.svg'),
          category: 'Discover',
          title: 'Corsica',
          text: 'Rare beauty, infinite variety, millennial traditions, charming historic towns, towering mountains, gastronomic delights, and a multitude of white sandy beaches: combine all these elements and one comes close to describing Corsica. But of course it’s more complex than that, and the more one scratches the surface, the more elusive and intriguing Corsica becomes.',
          cta: 'View more',
          linkId: 30,
          linkType: 'page',
        },
        {
          index: 3,
          category: 'Discover',
          bgImage: require('../assets/img/src/illustrations/table-setting.svg'),
          title: 'Greece',
          text: 'Since it laid the foundations for Mediterranean learning, culture and aesthetics all those millennia ago, Greece has inevitably changed. One thing that remains the same, however, is filoxenia, a uniquely Greek concept of hospitality that is at once innate and a moral obligation. Greece inspires with its dazzling beauty, its vibrant colours and its immense historical patrimony, but it is the genuine warmth with which visitors are welcomed that truly sets it apart.',
          cta: 'View more',
          linkId: 1087,
          linkType: 'page',
        },
        {
          index: 4,
          category: 'Discover',
          bgImage: require('../assets/img/src/illustrations/table-setting.svg'),
          title: 'Puglia',
          text: 'The heel of Italy, Puglia extends for some 400km from the north to its southernmost tip (finibus terrae to the Romans). Its coastline is lapped by the Adriatic and the Ionian seas and dotted with magnificent beaches and coves; its numerous pretty towns and villages are full of architectural, historical and cultural interest; and its excellent cuisine is humble by tradition and tasty by nature.',
          cta: 'View more',
          linkId: 28,
          linkType: 'page',
        },
        {
          index: 5,
          category: 'Discover',
          bgImage: require('../assets/img/src/illustrations/table-setting.svg'),
          title: 'Tuscan Islands',
          text: 'Scattered in the Tyrrhenian Sea between the west coast of Italy and Corsica, the Tuscan Archipelago comprises seven evocatively named main islands, including Elba, Giglio, Montecristo, Pianosa, and Capraia. Part of a national park, they are known for their pristine beauty, their vibrant marine life and, in the case of Capraia and a couple of others, their off-the-beaten-track tranquillity.',
          cta: 'View more',
          linkId: 835,
          linkType: 'page',
        },
      ];
    },
  },
  mounted() {
    this.skey = this.newUuidKey();
    // console.log('slideshowData', this.slideshowData)

    // let pages = this.$store.getters['pages/allPages'];
    // pages.forEach(e => {
    //     console.log('Page path is  = ', e.paths[0].path, ' ---- Page id is  = ', e.id);
    // });

    // NEW GA - push Custom GTM pageView event (on each page template)
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'Pageview', id_villa: undefined, page_type: 'Homepage' });
  },
};
</script>

<style lang="scss" scoped>
@import '../assets/styles/settings/config.scss';

.homepage {
  max-width: 1920px;
  margin: 0 auto;
  &__search {
    padding: 24px;
  }
  &__intro {
    padding: 3em 1em;
    font-style: normal;
    @media screen and (max-width: 480px) {
      font-size: 24px;
    }
  }
  &__collections--cta {
    a {
      margin: 3em 0 4em;
    }
  }
}

 </style>
